import Header from './Header';
import BottomNav from './BottomNav';
import AppFooter from './AppFooter';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  return (
    <div className="mx-auto flex min-h-screen max-w-lg flex-col bg-background">
      <Header />
      <main className="flex-1 pb-2">{children}</main>
      <AppFooter />
      <div className="pb-20" />
      <BottomNav />
    </div>
  );
};

export default AppLayout;
